import Animation from './animations';

/* eslint-disable no-console */
export default () => {
  const $body = jQuery('body');
  const $animationWrapper = jQuery('.animation--wrapper');
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  const getOS = () => {
    var userAgent = window.navigator.userAgent;
    var platform = window.navigator.platform;
    var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    var os = null;
  
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'mac-os';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'ios';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'windows';
    } else if (/Android/.test(userAgent)) {
      os = 'android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'linux';
    }
  
    return os;
  };

  $body.addClass(getOS());

  if ( isIE11 ) {
    $body.addClass('ie11');
  }

  // Hero section
  if ( jQuery('#hero').length ) {
    const slides = jQuery('#hero').find('.hero--wrapper').length;

    jQuery('#hero').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: slides > 1,
      draggable: false,
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  }

  // Testimonials
  if ( jQuery('.testimonials--list').length ) {
    jQuery('.testimonials--list').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      dots: false,
      fade: true,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><svg width="25.217" height="49.02" viewBox="0 0 25.217 49.02"><path id="Path_2" data-name="Path 2" d="M0,0,24.156,24.156,48.313,0" transform="translate(24.863 0.354) rotate(90)" fill="none" stroke="#707070" stroke-width="1"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="25.217" height="49.02" viewBox="0 0 25.217 49.02"><path id="Path_2238" data-name="Path 2238" d="M0,24.156,24.156,0,48.313,24.156" transform="translate(24.51 0.354) rotate(90)" fill="none" stroke="#707070" stroke-width="1"/></svg></button>',
    });
  }

  // Carousel
  const $carousels = jQuery('.carousel');
  if ( $carousels.length ) {

    for (let i = 0; i < $carousels.length; i++) {
      const $carousel = jQuery($carousels[i]);
      const slides = $carousel.closest('.carousel--wrapper').hasClass('big_letter_section--type-big') ? 2 : 4;
      
      $carousel.slick({
        infinite: true,
        slidesToShow: slides,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: slides === 4 ? 3 : slides,
            }
          }
        ]
      });
    }
  }

  jQuery('#header').on('click', '.menu-item-has-children', (e) => {
    if ( !e.target.href ) {
      e.preventDefault();
      jQuery(e.target).toggleClass('submenu-open').find('.sub-menu').stop().slideToggle(350);
    }
  });

  jQuery('.hamburger').on('click', (e) => {
    e.preventDefault();
    
    jQuery('.hamburger').toggleClass('is-active');
    $body.toggleClass('mobile-menu--open');
  });

  const scrollToggleClass = () => {
    if ( jQuery(window).scrollTop() > 0 && !$body.hasClass('scroll') ) {
      $body.addClass('scroll');
    } else if ( jQuery(window).scrollTop() === 0 && $body.hasClass('scroll') ) {
      $body.removeClass('scroll');
    }
  };

  jQuery(window).on('scroll', () => {
    window.requestAnimationFrame(() => {
      scrollToggleClass();
    });
  });

  scrollToggleClass();

  if ( $animationWrapper.length ) {
    new Animation($animationWrapper);
  }
};
